import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewbox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.00004 0.333496C3.32404 0.333496 0.333374 3.32416 0.333374 7.00016C0.333374 10.6762 3.32404 13.6668 7.00004 13.6668C10.676 13.6668 13.6667 10.6762 13.6667 7.00016C13.6667 3.32416 10.676 0.333496 7.00004 0.333496ZM1.66671 7.00016C1.66671 6.40083 1.77071 5.8255 1.95404 5.2875L3.00004 6.3335L4.33337 7.66683V9.00016L5.66671 10.3335L6.33337 11.0002V12.2875C3.70737 11.9575 1.66671 9.71483 1.66671 7.00016ZM11.22 10.2488C10.7847 9.89816 10.1247 9.66683 9.66671 9.66683V9.00016C9.66671 8.64654 9.52623 8.3074 9.27618 8.05735C9.02613 7.80731 8.687 7.66683 8.33337 7.66683H5.66671V5.66683C6.02033 5.66683 6.35947 5.52635 6.60952 5.27631C6.85956 5.02626 7.00004 4.68712 7.00004 4.3335V3.66683H7.66671C8.02033 3.66683 8.35947 3.52635 8.60952 3.27631C8.85956 3.02626 9.00004 2.68712 9.00004 2.3335V2.0595C10.952 2.85216 12.3334 4.76683 12.3334 7.00016C12.3333 8.17663 11.9416 9.31959 11.22 10.2488Z",
  fill: "#002B72"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}